import { TextArea } from "@kazaar-platform/design-system";
import { Controller, useFormContext } from "react-hook-form";
import { type ControlledTextAreaProps } from "./ControlledTextArea.types";

const ControlledTextArea = ({
  name,
  ...textFieldProps
}: ControlledTextAreaProps) => {
  const { control, formState } = useFormContext();

  const error = formState.errors[name];

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <TextArea
          {...textFieldProps}
          errorMessage={error?.message?.toString() || ""}
          hasError={!!error}
          value={field.value?.toString()}
          label={textFieldProps.label}
          onChange={field.onChange}
        />
      )}
    />
  );
};

export { ControlledTextArea };
